import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ViewRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CardView } from 'src/app/interfaces/cardview';
import { HTTPService } from 'src/app/services/http.service';

@Component({
    selector: 'anuncios',
    templateUrl: './anuncios.component.html',
    styleUrls: ['./anuncios.component.scss'],
    standalone: false
})
export class AnunciosComponent implements OnInit, AfterViewInit {

  title:string = "NAME";
  img:string = "IMAGE";
  pk:string ="CODEPRODUCT"
  options:Object[] = [];
  
  editface = false;
  row:CardView = null;

  constructor(private http:HTTPService,private routerParam:ActivatedRoute, private cd:ChangeDetectorRef) {
    
   }

  ngOnInit() {
     
  }

  ngAfterViewInit(){
  }

  ngOnDestroy(){
    this.cd.detach();
  }

  clickedRow(row:CardView){
    this.row = row;
    setTimeout(()=>{
      this.editface = true;

      setTimeout(() => {
        if (this.cd !== null && this.cd !== undefined &&
          !(this.cd as ViewRef).destroyed) {
          this.cd.detectChanges();
        }
        }, 250);
      
    },700)
    
  }
}
